import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const BulletinIcon = createIcon({
  displayName: 'BulletinIcon',
  viewBox: '0 0 22 26',
  path: (
    <>
      <path
        d='M3.93 4.32002L1.36 1.77003C1.21 1.62003 1.21 1.36 1.36 1.21C1.52 1.06 1.77 1.06 1.92 1.21L4.49 3.76002C4.65 3.91002 4.65 4.16002 4.49 4.32002C4.34 4.48002 4.08 4.48002 3.93 4.32002Z'
        fill='#5CB5AC'
      />
      <path
        d='M3.10999 6.23999H0.330017C0.150017 6.23999 0 6.09 0 5.91V5.78C0 5.6 0.150017 5.45001 0.330017 5.45001H3.10999C3.28999 5.45001 3.44 5.6 3.44 5.78V5.91C3.44 6.1 3.29999 6.23999 3.10999 6.23999Z'
        fill='#5CB5AC'
      />
      <path
        d='M5.45001 3.07001V0.350006C5.45001 0.160006 5.60999 0 5.79999 0H5.89001C6.08001 0 6.23999 0.160006 6.23999 0.350006V3.07001C6.23999 3.26001 6.08001 3.42001 5.89001 3.42001H5.79999C5.60999 3.42001 5.45001 3.26001 5.45001 3.07001Z'
        fill='#5CB5AC'
      />
      <path
        d='M18.62 14.59V10.19C18.62 6.62 15.64 3.72 11.95 3.72H10.04C6.35998 3.72 3.37 6.62 3.37 10.19V14.59C3.37 16.42 2.36999 18.11 0.73999 19.04C0.41999 19.22 0.220032 19.55 0.220032 19.91V20.83C0.220032 21.51 0.78998 22.06 1.47998 22.06H20.49C21.19 22.06 21.75 21.51 21.75 20.83V19.91C21.75 19.55 21.55 19.22 21.23 19.04C19.62 18.11 18.62 16.42 18.62 14.59Z'
        fill='#FA704D'
      />
      <path
        d='M11.22 25.32H10.73C9.23998 25.32 8.03003 24.15 8.03003 22.7V22.46H13.92V22.7C13.92 24.15 12.71 25.32 11.22 25.32Z'
        fill='#5CB5AC'
      />
      <path
        d='M12.75 5.20999H9.20001V3.20001C9.20001 2.46001 9.82002 1.86002 10.58 1.86002H11.36C12.12 1.86002 12.74 2.46001 12.74 3.20001V5.20999H12.75Z'
        fill='#F75266'
      />
    </>
  ),
});
